import FillButton from '@components/Buttons/Fill';
import styled from '@emotion/styled';

export const Container = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 14px;
  box-sizing: border-box;
  background-color: #000000;
`;

export const IntervieweeInfo = styled.div`
  overflow: hidden;
  display: -webkit-box;
  align-items: center;
  height: 43px;
  white-space: pre-wrap;
  color: #ffffff;
  font-size: 14px;
  font-weight: 400;
  margin: auto 0;
  text-overflow: ellipsis;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
`;

export const IntervieweeArea = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  width: 410px;
`;

export const VideoWrapper = styled.video`
  width: 80px;
  height: 60px;
  transform: rotateY(180deg);
  background: url('/img/background.png');
`;

export const HelpArea = styled.div`
  display: flex;
  width: 410px;
  justify-content: end;
`;

export const HelpButton = styled(FillButton)`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 4px;
  width: 100px;
  height: 36px;
  font-size: 14px;
  font-weight: 400;
  color: #ffffff;
  background: #6d64e5;
  border-radius: 5px;
`;

export const HelpIcon = styled.div`
  width: 22px;
  height: 22px;
  background: url('/img/help.png') no-repeat center center;
`;
